/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Download_FailedInputs */

const en_mobile_download_failed = /** @type {(inputs: Mobile_Download_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download failed. Please try again.`)
};

const es_mobile_download_failed = /** @type {(inputs: Mobile_Download_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo descargar. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Download failed. Please try again." |
*
* @param {Mobile_Download_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_download_failed = /** @type {((inputs?: Mobile_Download_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Download_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_download_failed(inputs)
	return en_mobile_download_failed(inputs)
});